var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{staticClass:"organization__select",attrs:{"hide-details":"","placeholder":"Organization","items":_vm.organizationsToShow,"menu-props":{
    offsetY: true,
    nudgeBottom: -3,
  }},on:{"change":_vm.organizationChanged},model:{value:(_vm.organizationId),callback:function ($$v) {_vm.organizationId=$$v},expression:"organizationId"}})}
var staticRenderFns = []

export { render, staticRenderFns }